'use strict';
angular.module("correspondentDetailModule", [])
    .controller("correspondentDetailController", ["$scope", "$modalInstance", "correspondentId", "trsHttpService", "$q", function($scope, $modalInstance, correspondentId, trsHttpService, $q) {

        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                correspondentId: correspondentId
            }
            $scope.data = {
                userInfo: {}
            }
        }
        
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            let defer = $q.defer();
            let params = {
                serviceid: "mlf_commuser",
                methodname: "findCommUser",
                ObjectId: $scope.status.correspondentId
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then((data) => {
                $scope.data.userInfo = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [cancel description] 取消/关闭
         * @return {[type]} [description]
         */
        $scope.cancel = function () {
        	$modalInstance.dismiss();
        }
    }]);